const LK_User =({color,width,height})=>{
    return(
        <svg fill={color} id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 116.99 116.99">
        {/* <defs>
            <style>
            .cls-1 {
                fill: #005c8e;
                stroke-width: 0px;
            }
            </style>
        </defs> */}
        <path d="M58.49,4.33c8.36,0,15.16,6.8,15.16,15.16s-6.8,15.16-15.16,15.16-15.16-6.8-15.16-15.16,6.8-15.16,15.16-15.16M58.49,0c-10.77,0-19.5,8.73-19.5,19.5s8.73,19.5,19.5,19.5,19.5-8.73,19.5-19.5S69.26,0,58.49,0h0ZM58.49,43.33c8.36,0,15.16,6.8,15.16,15.16v54.16h-20.22c-5.57,0-10.11-4.54-10.11-10.11v-44.05c0-8.36,6.8-15.16,15.16-15.16M58.49,39c-10.77,0-19.5,8.73-19.5,19.5v44.05c0,7.98,6.47,14.44,14.44,14.44h24.55v-58.49c0-10.77-8.73-19.5-19.5-19.5h0Z"/>
        </svg>
    );
};

export default LK_User;
